import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import {
  faUser,
  faPlane,
  faUserInjured,
} from "@fortawesome/free-solid-svg-icons";
import "./PlayerActivity.scss";

import { CoachScheduleProp } from "Interfaces/Components/Shared/DashboardInterface";

const CoachActivity: React.FC<{
  coachSchedule: CoachScheduleProp;
  todayDate: string;
}> = ({ coachSchedule, todayDate }) => {
  const navigate = useNavigate();

  const handleRowClick = (type: string) => {
    navigate(
      `/user_schedules?of_type=${type}&start_date=${todayDate}&end_date=${todayDate}&entity_type_for_academy_schedules=Coach`
    );
  };

  const activities = [
    {
      type: "leave",
      label: "Coaches on Leave",
      count: coachSchedule.Leave,
      icon: faUser,
      badgeColor: "bg-primary",
      iconColor: "text-primary",
    },
    {
      type: "travel",
      label: "Coaches Travelling",
      count: coachSchedule.Travel,
      icon: faPlane,
      badgeColor: "bg-warning",
      iconColor: "text-warning",
    },
    {
      type: "injury",
      label: "Coaches Injured",
      count: coachSchedule.Injury,
      icon: faUserInjured,
      badgeColor: "bg-danger",
      iconColor: "text-danger",
    },
  ];

  // Mapping Activities
  const activityItems = activities.map((activity, index) => (
    <div
      key={index}
      className="activity-item d-flex align-items-center my-3"
      onClick={() => handleRowClick(activity.type)}
    >
      <FontAwesomeIcon
        icon={activity.icon}
        className={`activity-icon ${activity.iconColor} me-3`}
        size="2x"
      />
      <span className="activity-label flex-grow-1">{activity.label}</span>
      <span className={`activity-count badge ${activity.badgeColor} fs-6`}>
        {activity.count}
      </span>
    </div>
  ));

  return (
    <div className="card top-players overflow-auto">
      <div className="card-body">
        {/* Today's Date */}
        <span
          className="text-muted position-absolute top-0 end-0 m-3"
          style={{ fontSize: "0.9rem" }}
        >
          {todayDate}
        </span>
        <h5 className="card-title">Coach Activities</h5>
        <div className="activity-list">{activityItems}</div>
      </div>
    </div>
  );
};

export default CoachActivity;
